export default __webpack_public_path__ + "static/illu_vaccine-ec059b0dd586804afb42eef466f92617.png";